import { render } from "./CorporatePlanCreate.vue?vue&type=template&id=2dc52832"
import script from "./CorporatePlanCreate.vue?vue&type=script&lang=js"
export * from "./CorporatePlanCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__